// routes/ALLRoutes.tsx
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import ProtectedRoute from "./protectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAppSelector, useAppDispatch } from "../../core/data/redux/hooks";
import { login } from "../../core/data/redux/authSlice";
import { jwtDecode } from "jwt-decode";
import Loader from "../../core/common/loader";
import PermissionLoader from "../../utils/PermissionLoader";

const ALLRoutes: React.FC = () => {
  const dispatch = useAppDispatch();
  const [ready, setReady] = useState(false);

  const userRole = useAppSelector((state) => state.auth.role);

  useEffect(() => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    const storedPermissions = localStorage.getItem("authPermissions");

    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        dispatch(
          login({
            token,
            role: decoded.role,
            user: decoded.user,
            sub: decoded.sub,
            employee_id: decoded.id,
            department: decoded.department,
            permissions: storedPermissions ? JSON.parse(storedPermissions) : {}, // or provide a proper empty fallback
          })
        );
      } catch (err) {
        console.error("Invalid token, removing...");
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");
      }
    }
    setReady(true);
  }, [dispatch]);

  if (!ready) {
    return <Loader />;
  }

  return (
    <>
      <PermissionLoader />
      <Routes>
        {/* Public Routes */}
        {publicRoutes.map((route, idx) => (
          <Route path={route.path} element={route.element} key={idx} />
        ))}

        {/* Authenticated Routes */}
        <Route element={<Feature />}>
          {authRoutes.map((route, idx) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <ProtectedRoute allowedRoles={route.allowedRoles}>
                  {route.element}
                </ProtectedRoute>
              }
            />
          ))}
        </Route>
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default ALLRoutes;
